import React from "react";
import { Link } from "react-router-dom";
import "../../../src/assets/css/home.css";

export default function Advantages() {

    return (
        <section className="advantages-section py-5 bg-white">
            <div className="text-center">
                <h1
                    className="py-3 text-primary"
                    style={{ fontWeight: 400 }}
                    data-aos="fade-up"
                >
                    Everything You Need. In One House.
                </h1>

                <div className="row align-items-center justify-content-center g-4 position-relative mt-3 pt-5">

                    {/* Left Column */}
                    <div className="col-12 col-md-3 support-img-section-left align-items-md-end text-md-end">
                        <div
                            className="support-img-text"
                            data-aos="fade-right"
                        >
                            <img
                                src="/assets/images/Home/advantages4.png"
                                alt="Customized Design Support"
                                className="support-img img-fluid mb-2"
                            />
                            <p>Customized</p>
                            <p>Design Support</p>
                        </div>

                        <div
                            className="support-img-text"
                            data-aos="fade-right"
                        >
                            <img
                                src="/assets/images/Home/advantages3.png"
                                alt="Strategic Supply Support"
                                className="support-img img-fluid mb-2"
                            />
                            <p>Strategic Supply</p>
                            <p>Support</p>
                        </div>
                    </div>

                    {/* Center Column (Video inside Frame) */}
                    <div className="col-12 col-md-6 d-flex justify-content-center">
                        <div
                            className="pc-video-container position-relative mx-auto"
                            data-aos="zoom-in"
                        >
                            <img
                                src="/assets/images/Home/advantage5.png"
                                alt="PC Frame"
                                className="pc-frame img-fluid"
                            />
                            <video
                                className="pc-screen-video position-absolute"
                                autoPlay
                                muted
                                loop
                                playsInline
                            >
                                <source src="/assets/videos/Advantages.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="col-12 col-md-3 support-img-section-left align-items-md-start text-md-start">
                        <div
                            className="support-img-text"
                            data-aos="fade-left"
                        >
                            <img
                                src="/assets/images/Home/advantages2.png"
                                alt="E-com & Dropshipping Support"
                                className="support-img img-fluid mb-2"
                            />
                            <p>E-com and</p>
                            <p>Dropshipping</p>
                            <p>Support</p>
                        </div>

                        <div
                            className="support-img-text"
                            data-aos="fade-left"
                        >
                            <img
                                src="/assets/images/Home/advantages1.png"
                                alt="Graphics & Marketing Support"
                                className="support-img img-fluid mb-2"
                            />
                            <p>Graphics and</p>
                            <p>Marketing Support</p>
                        </div>
                    </div>
                </div>

                <div
                    className="mt-5"
                    data-aos="fade-up"
                >
                    <Link to="/services" className="primary-button-cta btn-lg px-4 fw-bold">
                        Explore All Services
                    </Link>
                </div>
            </div>
        </section>
    );
}